module.exports = "/_next/static/images/all-3f0d29c22d9d088b9e1a19fa1765027c.svg";